import { createContext, useContext } from 'react';

interface AIInsightsContextType {
	aiInsightsEnabled: boolean;
	aiInsightsApproved: boolean;
	needsViewerApproval: boolean;
	refetchNeedsAIInsightsApproval: () => void;
	openAIInsightsApprovalModal: () => void;
	insightsLoading: boolean;
	showAIInsightsFeedback: boolean;
	streamingInsightsData: Record<string, string>;
}

export const AIInsightsContext = createContext<AIInsightsContextType>({
	aiInsightsEnabled: false,
	aiInsightsApproved: false,
	needsViewerApproval: false,
	refetchNeedsAIInsightsApproval: () => {},
	openAIInsightsApprovalModal: () => {},
	insightsLoading: false,
	showAIInsightsFeedback: false,
	streamingInsightsData: {},
});

export function useAIInsightsContext() {
	return useContext(AIInsightsContext);
}
